import React from 'react';
import PropTypes from 'prop-types';

import styles from './componentStyles/horizontalSmallTitle.module.css';

const HorizontalSmallTitle = (props) => (
  <>
    <h1 className={styles.title}>{props.title}</h1>
    <div className={styles.subtitle}>{props.subtitle}</div>
  </>
);

HorizontalSmallTitle.propTypes = {
  title: [PropTypes.string, PropTypes.node],
  subtitle: [PropTypes.string, PropTypes.node],
};

export default HorizontalSmallTitle;
